import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[plugin]',
    standalone: false
})
export class PluginDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
